import React from 'react'

const HAYFTSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2101:120407)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.8885 1.54416C7.39616 2.02571 7.00244 2.59865 6.72938 3.2309C6.44622 3.88889 6.30158 4.58762 6.30362 5.30673C6.30362 5.98509 6.44215 6.69197 6.71716 7.41108C6.94532 8.01203 7.27737 8.63539 7.69905 9.26486C8.36723 10.261 9.28597 11.3 10.4268 12.3531C12.3193 14.099 14.1893 15.3029 14.2688 15.3538L14.7516 15.6635C14.9655 15.8 15.2405 15.8 15.4544 15.6635L15.9372 15.3538C16.0166 15.3049 17.8888 14.099 19.7792 12.3531C20.92 11.3 21.8387 10.261 22.5069 9.26486C22.9286 8.63539 23.2586 8.01203 23.4888 7.41108C23.7638 6.69197 23.9024 5.98509 23.9024 5.30673C23.9024 4.58762 23.7577 3.88889 23.4746 3.2309C23.2022 2.59824 22.8084 2.02517 22.3154 1.54416C21.8204 1.05932 21.2439 0.678377 20.6042 0.413551C19.9422 0.138539 19.2414 1.43205e-05 18.5182 1.43205e-05C17.5139 1.43205e-05 16.5341 0.275026 15.6825 0.794494C15.4788 0.918758 15.2853 1.05525 15.102 1.20396C14.9186 1.05525 14.7251 0.918758 14.5214 0.794494C13.6699 0.275026 12.69 1.43205e-05 11.6857 1.43205e-05C10.9698 -0.00163344 10.2608 0.138932 9.59969 0.413551C8.96214 0.67734 8.38122 1.06117 7.8885 1.54416ZM1.03022 22.3766L3.23071 27.2234C3.52229 27.8657 4.30656 28.1131 4.91387 27.7544L7.98115 25.9427C9.24026 25.199 10.6542 24.7564 12.1126 24.6494L21.0533 23.9937C21.7361 23.9437 22.3639 23.6011 22.7754 23.054L28.486 15.4631C28.9356 14.8655 28.7966 14.0138 28.1804 13.5901C27.6274 13.2099 26.8767 13.3074 26.4393 13.8163L20.8828 20.2799C20.8078 20.3672 20.7245 20.4469 20.634 20.518C20.3247 20.761 19.9434 20.8942 19.5501 20.8965L13.2345 20.9341C12.9982 20.9355 12.8096 20.7377 12.8222 20.5018C12.8337 20.286 13.0106 20.1161 13.2266 20.1133L18.1226 20.0489C18.8862 20.0388 19.4999 19.417 19.4999 18.6534C19.4999 17.8826 18.8751 17.2577 18.1043 17.2577H10.1273L8.79343 17.3183C8.40393 17.336 8.0248 17.4495 7.6896 17.6486L4.59627 19.4863L1.62936 20.802C1.02685 21.0692 0.757751 21.7764 1.03022 22.3766Z"
          fill={props?.fill ?? '#3E4685'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2101:120407">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HAYFTSvg
